export const insuredPersonalConstants = [
    {
        name: "Fullname",
        key: "fullname",
        value: "",
        show: true,
    },
    {
        name: "Date of Birth",
        key: "dateOfBirth",
        value: "",
        show: true,
    },
    {
        name: "Gender",
        key: "gender",
        value: "",
        show: true,
    },
    {
        name: "Father's Name",
        key: "fatherName",
        value: "",
        show: true,
    },
    {
        name: "Mother's Name",
        key: "motherName",
        value: "",
        show: true,
    },
    {
        name: "Place Of Birth",
        key: "placeOfBirth",
        value: "",
        show: true,
    },
    {
        name: "Marital Status",
        key: "maritalStatus",
        value: "",
        show: true,
    },
    {
        name: "Maiden Name",
        key: "maidenName",
        value: "",
        show: true,
    },
    {
        name: "Spouse Name",
        key: "spouseName",
        value: "",
        show: true,
    },
    {
        name: "Education",
        key: "education",
        value: "",
        show: true,
    },
    {
        name: "Occupation Type",
        key: "occupationType",
        value: "",
        show: true,
    },
    {
        name: "Identity Type",
        key: "identityType",
        value: "",
        show: true,
    },
    {
        name: "Identity Number",
        key: "identityNumber",
        value: "",
        show: true,
    },
    {
        name: "Residential Satus",
        key: "residentialStatus",
        value: "",
        show: true,
    },
    {
        name: "Relationship",
        key: "relationWithProposer",
        value: "",
        show: true,
    },
    {
        name: "PAN",
        key: "panNumber",
        value: "",
        show: true,
    },
    {
        name: "Age Proof",
        key: "ageProof",
        value: "",
        show: true,
    },
    {
        name: "Submit Form 60",
        key: "submitForm60",
        value: "",
        show: true,
    },
    {
        name: "Whether PAN Applied?",
        key: "panApplied",
        value: "",
        show: true,
    },
    {
        name: "Date of Application",
        key: "dateOfApplication",
        value: "",
        show: true,
    },
    {
        name: "Acknowledgement No.",
        key: "acknowledgementNumber",
        value: "",
        show: true,
    },
    {
        name: "Agricultural Income",
        key: "agriculturalIncome",
        value: "",
        show: true,
    },
    {
        name: "Other than agricultural Income",
        key: "otherThanAgriculturalIncome",
        value: "",
        show: true,
    },
    {
        name: "Are you assessed to tax?",
        key: "assessedToTax",
        value: "",
        show: true,
    },
    {
        name: "Ward/Circle/Range where last return of income was field",
        key: "circleOfLastReturnField",
        value: "",
        show: true,
    },
    {
        name: "Reasons for not having PAN/General Index Register number",
        key: "reasonForNotHavingPanOrIGNumber",
        value: "",
        show: true,
    },
    ];

    export const insuredEmploymentConstants = [
    {
        name: "Employee Id",
        key: "employeeId",
        value: "",
        show: true,
    },
    {
        name: "Name of Organisation",
        key: "organizationName",
        value: "",
        show: true,
    },
    {
        name: "Job Description",
        key: "jobDescription",
        value: "",
        show: true,
    },
    {
        name: "Other Job Description",
        key: "otherJobDescription",
        value: "",
        show: true,
    },
    {
        name: "Period Of Working",
        key: "periodOfWorkingInYear",
        value: "",
        show: true,
    },
    {
        name: "Other Source of income",
        key: "otherSourceIncome",
        value: "",
        show: true,
    },
    {
        name: "Salaried Type",
        key: "salariedType",
        value: "",
        show: true,
    },
    {
        name: "Source Of Funds/Income",
        key: "sourceOfFundsOrIncome",
        value: "",
        show: true,
    },
    {
        name: "Annual Income",
        key: "annualIncome",
        value: "",
        show: true,
    },
    ];

    export const insuredPermanetAddConstants = [
    {
        name: "Adress Line 1",
        key: "addressLine1",
        value: "",
        show: true,
    },
    {
        name: "Address Line 2",
        key: "addressLine2",
        value: "",
        show: true,
    },
    {
        name: "LandMark",
        key: "landmark",
        value: "",
        show: true,
    },
    {
        name: "Pincode",
        key: "pinCode",
        value: "",
        show: true,
    },
    {
        name: "City",
        key: "city",
        value: "",
        show: true,
    },
    {
        name: "State",
        key: "state",
        value: "",
        show: true,
    },
    {
        name: "Alt. Mobile Number",
        key: "alterNateMobNumber",
        value: "",
        show: true,
    },
    {
        name: "Mobile Number",
        key: "mobileNumber",
        value: "",
        show: true,
    },
    {
        name: "Email",
        key: "email",
        value: "",
        show: true,
    },
    {
        name: "Same as Permanent Address",
        key: "sameAsPermanentAddress",
        value: "",
        show: true,
    },
    ];
    export const insuredCorrespondenceAddConstants = [
    {
        name: "Adress Line 1",
        key: "addressLine1",
        value: "",
        show: true,
    },
    {
        name: "Address Line 2",
        key: "addressLine2",
        value: "",
        show: true,
    },
    {
        name: "LandMark",
        key: "landmark",
        value: "",
        show: true,
    },
    {
        name: "Pincode",
        key: "pinCode",
        value: "",
        show: true,
    },
    {
        name: "City",
        key: "city",
        value: "",
        show: true,
    },
    {
        name: "State",
        key: "state",
        value: "",
        show: true,
    },
];
